/**
 * Formats a whole number of seconds as an "H:MM:SS" clock string. Shared by
 * every countdown display in the app (send-money device-switch limit,
 * credential-verify lockouts, facial-verification processing timer).
 */
export function formatSecondsAsClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/** Whole seconds remaining until an ISO instant, floored at 0. */
export function secondsUntil(isoDate: string): number {
  return Math.max(
    0,
    Math.floor((new Date(isoDate).getTime() - Date.now()) / 1000)
  );
}
